import { useEffect, useState } from 'react';
import { menuFavoritesKey, parseMenuFavorites, resolveMenuFavorites, toggleMenuFavorite, MAX_MENU_FAVORITES } from '../utils/menuFavorites';

export default function useMenuFavorites(user, storeId, services) {
  const key = menuFavoritesKey(user, storeId);
  const [saved, setSaved] = useState({ key: null, ids: [] });
  const [notice, setNotice] = useState('');
  useEffect(() => {
    setNotice('');
    const read = () => {
      try { setSaved({ key, ids: key ? parseMenuFavorites(window.localStorage.getItem(key)) : [] }); }
      catch { setSaved({ key, ids: [] }); setNotice('이 브라우저에서는 즐겨찾기를 저장할 수 없습니다.'); }
    };
    read();
    const sync = (event) => { if (event.key === key || event.key === null) read(); };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, [key]);

  const favorites = resolveMenuFavorites(saved.key === key ? saved.ids : [], services);
  const toggle = (id) => {
    if (!key || !services.some((service) => service.id === id && !service.devOnly)) return;
    const ids = favorites.map((service) => service.id);
    if (!ids.includes(id) && ids.length >= MAX_MENU_FAVORITES) {
      setNotice('즐겨찾기는 최대 4개입니다. 별을 다시 눌러 해제할 수 있습니다.');
      return;
    }
    const next = toggleMenuFavorite(ids, id);
    setSaved({ key, ids: next });
    try { window.localStorage.setItem(key, JSON.stringify(next)); setNotice(''); }
    catch { setNotice('저장 공간에 접근할 수 없어 이번 화면에서만 유지됩니다.'); }
  };
  return { favorites, toggle, notice, canSave: Boolean(key) };
}
